// extracted by mini-css-extract-plugin
export default {"prizeTitle":"TEUKM3ECpxerdwC3PIRg","descriptionColumn":"Bb2FRDDXjspY_bGWBSLg"};